import RepositoryFactory from '@/repository/RepositoryFactory';
import { PostShiftCategoryRequest, PutShiftCategoryRequest } from '@/model/repository';
import { fetchShiftPatterns } from '@/service/shift/shiftPatterns';
import { sortShiftCategories } from '@/service/shift/shiftCategoriesOrder';
const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * シフトカテゴリを取得
 */
export async function fetchShiftCategories(idGenerator: () => string) {
  const [catRes, patterns] = await Promise.all([
    shiftServiceRepositories.shiftCategories.index(),
    fetchShiftPatterns(idGenerator),
  ]);
  const result = catRes.data.map((category) => ({
    ...category,
    isCategoryOpen: true, // アコーディオンの開閉状態。初期はtrue。画面の状態なので本当はこいつに持たせたくない
    shiftPatterns: patterns.filter((pattern) => pattern.shiftCategoryId === category.shiftCategoryId),
  }));
  sortShiftCategories(result);
  return result;
}

/**
 * シフトカテゴリを更新
 */
export async function updateShiftCategories(id: string, payload: PutShiftCategoryRequest) {
  const fetchedShiftCategories = await shiftServiceRepositories.shiftCategories.update(id, payload);
  return fetchedShiftCategories.data;
}

/**
 * シフトカテゴリを作成
 */
export async function storeShiftCategories(payload: PostShiftCategoryRequest) {
  const fetchedShiftCategories = await shiftServiceRepositories.shiftCategories.create(payload);
  return fetchedShiftCategories.data;
}
